import { clearTunnelOrigin } from '../Shared/utils/tunnelOrigin.js';
import { clearPaymentSuccessContext } from '../Payment/utils/paymentSuccessStorage.js';
import { clearNavigationHistory } from '../Shared/hooks/useNavigationHistory.js';

const AUTH_LOCAL_STORAGE_KEYS = [
    'userToken',
    'roleId',
    'email',
    'isLoggedIn',
];

const ACCOUNT_LOCAL_STORAGE_KEYS = [
    'loginEmail',
    'selectedPlan',
    'selectedPeriod',
];

const SESSION_STORAGE_KEYS = [
    'authRefreshedThisSession',
];

function removeStorageKeys(storage, keys) {
    for (const key of keys) {
        try {
            storage.removeItem(key);
        } catch {
            // ignore private mode / quota errors
        }
    }
}

/** Clears auth tokens and profile fields (logout). */
export function clearUserSession() {
    removeStorageKeys(localStorage, AUTH_LOCAL_STORAGE_KEYS);
    removeStorageKeys(sessionStorage, SESSION_STORAGE_KEYS);
}

/** Removes all client-side account and session data after account deletion. */
export function clearAccountClientData() {
    clearUserSession();
    removeStorageKeys(localStorage, ACCOUNT_LOCAL_STORAGE_KEYS);
    clearTunnelOrigin();
    clearPaymentSuccessContext();
    clearNavigationHistory();
}
